export enum InPersonWorkingHoursFeatureFlag {
  /** The default, with no new functionality */
  LEGACY_VIEW = 'legacy-view',
  /** Shows the old view with new functionality introduced (v0) */
  LEGACY_WITH_AVAILABILITY_TYPE = 'legacy-with-availability-type',
  /** Shows the newly redesigned availability pages, including the new functionality */
  NEW_AVAILABILITY_PAGES = 'new-availability-pages',
}
